//const API_URL = 'http://localhost:1920/api';
const CDN_URL = "http://localhost:1920/image";
const API_URL = "https://wa-securitas-sgk-api.azurewebsites.net";
//const API_URL = "https://localhost:7099"

//const API_EbasvuruUrl = "https://localhost:7120";
const API_EbasvuruUrl = "https://wa-securitas-ebasvuru-api-test.azurewebsites.net";
//const API_EbasvuruUrl = "https://wa-securitas-ebasvuru-api.azurewebsites.net";
//const API_EbasvuruUrl = "https://api.dijitalsgk.com";

///securitas
const DefaultIcon = "/securitas.png";
const MenuIcon = "/securitas_menu.svg";
const SSOLogin = true;

/// PMA
//const DefaultIcon = "/pma-05.png";
//const MenuIcon = "/pma-03.png";


const VERSION = "1.0";

const MAX_RESULT = 10;
const COOKIE_DOMAIN = undefined;

const COOKIE_CONFIG = {
  maxAge: 60 * 60 * 24 * 120,
  path: "/",
  domain: COOKIE_DOMAIN,
  secure: false,
  sameSite: "Lax",
};

const Config = {
  API_URL,
  CDN_URL,
  MAX_RESULT,
  VERSION,
  COOKIE_CONFIG,
  API_EbasvuruUrl,
  DefaultIcon,
  MenuIcon,
  SSOLogin
};

export default Config;
